











































































































import Vue from 'vue'
import { mapState } from 'vuex'
import { ApiResponse, Product } from '@/interfaces'

// Interface après transformation
interface ProductOption {
  id: string
  name: string
}

interface ProductGroup {
  categoryKey: string
  categoryLabel: string
  options: ProductOption[]
}

export default Vue.extend({
  props: {
    items: {
      type: Array,
      required: false,
      default: () => {
        return []
      },
    },
  },
  data() {
    return {
      busy: false,
      viewportWidth: 0,
      chosenProduct: null,
      products: [] as ProductGroup[],
    }
  },
  computed: {
    ...mapState(['user']),
  },
  mounted() {
    this.loadProducts()

    this.viewportWidth = window.innerWidth

    window.addEventListener('resize', this.onResize)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.onResize)
  },
  methods: {
    onResize() {
      this.viewportWidth = window.innerWidth
    },
    closeModal(updateCheckboxValue = false) {
      this.chosenProduct = null

      this.$emit('closeFeeModal', updateCheckboxValue)
    },
    submit(mode = 'add') {
      this.busy = true
      this.$api
        .put(`/requisitionitems/fee/add`, {
          items: this.items,
          data: this.chosenProduct,
          mode: mode,
        })
        .then((response) => {
          const apiResponse = response.data as ApiResponse

          const countItems = apiResponse.data.count
          this.$emit('updateItems', apiResponse.data.items)
          this.$notify({
            type: 'success',
            title: 'Succès',
            message: `Le frais a été appliqué sur ${countItems} lot(s). Vous pouvez ajoutez d'autres frais ou fermer la fenêtre`,
          })
        })
        .finally(() => {
          this.busy = false
          //this.closeModal(false)
        })
    },
    removeFee() {
      this.busy = true
      this.$api
        .put(`/requisitionitems/fee/remove`, {
          items: this.items,
          data: this.chosenProduct,
        })
        .then((response) => {
          const apiResponse = response.data as ApiResponse

          const countItems = apiResponse.data.count
          this.$emit('updateItems', apiResponse.data.items)
          this.$notify({
            type: 'success',
            title: 'Succès',
            message: `Le frais a été supprimé de ${countItems} lot(s).`,
          })
        })
        .finally(() => {
          this.busy = false
        })
    },
    loadProducts() {
      this.products = []

      const items = this.items.join(',')

      this.$api
        .get('/products', {
          params: {
            items: items,
            type: 'requisition',
          },
        })
        .then((response) => {
          const apiResponse = response.data as ApiResponse

          this.products = this.groupProductsByCategory(apiResponse.data)
        })
    },
    groupProductsByCategory(products: Product[]): ProductGroup[] {
      const grouped: { [key: string]: { id: string; name: string }[] } = {}

      const defaultCategoryLabels: { [key: string]: string } = {
        hono_buyer: 'Honoraires acheteur',
        hono_seller: 'Honoraires vendeur',
        hono_inventory: 'Honoraires inventaire',
        ie: 'Frais IE',
        drouot: 'Frais Drouot',
        expert: 'Expert',
        logistic: 'Transport',
        taxes: 'Taxes',
      }

      const configuredCategoryLabels: { [key: string]: string } = {}
      const configuredCategoryOrder: string[] = []
      const structures = this.user?.client?.structures ?? []
      structures.forEach((structure: Record<string, any>) => {
        const categories = structure?.productCategoryCompta
        if (Array.isArray(categories)) {
          categories.forEach((category: Record<string, unknown>) => {
            if (typeof category?.value === 'string' && category.value) {
              configuredCategoryLabels[category.value] =
                (category.label as string) || defaultCategoryLabels[category.value] || category.value

              if (!configuredCategoryOrder.includes(category.value)) {
                configuredCategoryOrder.push(category.value)
              }
            }
          })
        }
      })

      const categoryLabels = {
        ...defaultCategoryLabels,
        ...configuredCategoryLabels,
      }

      // Parcours des produits pour les regrouper par catégorie
      products.forEach((item) => {
        const categoryKey = item.category ?? 'divers' // Utiliser "divers" si category est null

        // Si la catégorie n'existe pas, la créer
        if (!grouped[categoryKey]) {
          grouped[categoryKey] = []
        }

        // Ajouter le produit à la catégorie correspondante
        grouped[categoryKey].push({ id: String(item.id), name: this.getLabel(item) })
      })

      const orderIndex = configuredCategoryOrder.reduce(
        (acc, key, index) => {
          acc[key] = index
          return acc
        },
        {} as Record<string, number>
      )

      // Retourner les groupes sous la forme de ProductGroup[] triés selon la config
      return Object.keys(grouped)
        .sort((a, b) => {
          const aIndex = Object.prototype.hasOwnProperty.call(orderIndex, a) ? orderIndex[a] : Number.MAX_SAFE_INTEGER
          const bIndex = Object.prototype.hasOwnProperty.call(orderIndex, b) ? orderIndex[b] : Number.MAX_SAFE_INTEGER

          if (aIndex !== bIndex) {
            return aIndex - bIndex
          }

          return (categoryLabels[a] ?? a).localeCompare(categoryLabels[b] ?? b)
        })
        .map(
        (categoryKey): ProductGroup => ({
          categoryKey,
          categoryLabel: categoryLabels[categoryKey] ?? 'Divers',
          options: grouped[categoryKey],
        })
        )
    },

    getLabel(product: Product) {
      return (
        product.name +
        ' - P.U ' +
        product.unitPriceExcludingTaxes +
        ' - ' +
        product.tvaRate +
        '% - ' +
        product.structure?.name
      )
    },
  },
})
